<script setup lang="ts">
import { Dialog } from 'primevue'

const visible = defineModel<boolean>({ required: true, default: false })

const data: Record<string, string> = {
    'Наименование организации': 'ООО ПКО "ХАБЕР"',
    'ИНН организации': '7743250388',
    'КПП организации': '774301001',
    'Расчетный счет': '40702810610000322394',
    'Наименования банка': 'АО "ТБанк"',
    'БИК банка': '044525974',
    'Корреспондентский счет': '30101810145250000974',
    'Назначение платежа': 'Погашение долга перед ООО ПКО "ХАБЕР"',
}
</script>

<template>
    <Dialog
        v-model:visible="visible"
        header="Реквизиты для оплаты задолженности"
        class="w-full md:w-[95%] lg:w-2/3"
        modal
        dismissable-mask>
        <div class="flex flex-col items-center gap-4 md:flex-row md:gap-8">
            <div class="shrink-0">
                <!-- QR here -->
                <img src="@assets/qr.png" class="h-[400px]" />
            </div>
            <div>
                <!-- Requisites -->
                <div
                    v-for="(value, key, idx) in data"
                    :key="key"
                    class="grid grid-cols-2 gap-4 py-3"
                    :class="{ 'border-t border-surface-200': idx !== 0 }">
                    <div class="text-caption-xs-reg text-surface-400 md:text-subtitle-14">
                        {{ key }}
                    </div>
                    <div class="text-body-14 font-bold text-primary-500 md:text-body-16">
                        {{ value }}
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
</template>
